<template>
  <div class="popup_in">
    <div class="popup">
      <img
        style="width:42px;margin-bottom:10px"
        src="/assets/img/svg/alert.svg"
      />
      <h2 class="title title--40">
        הניתוחים הבאים לא שובצו:
        <br />
      </h2>

      <div style="margin:20px 0; ">
        <table class="table table-striped table-policies" cellspacing="0">
          <thead>
            <th class="tx--white">מספר דרכון</th>
            <th class="tx--white">שם המטופל</th>
            <th class="tx--white">שם חברת הביטוח</th>
            <th class="tx--white">סיבה</th>
          </thead>
          <tbody>
            <tr v-for="(error, index) in errors" :key="index">
              <td>{{ error.passport }}</td>
              <td>{{ error.patient_name }}</td>
              <td>{{ error.insurance_name }}</td>
              <td>{{ error.reason }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex--content--center">
        <a class="bt_blue bt-policies" @click.prevent="$emit('close')">סגור</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurgEditErrors",
  props: {
    errors: {
      // [{passport,patient_name,insurance_name,reason}]
      type: Array,
      required: true
    }
  }
};
</script>

<style>
.table-row {
  display: flex;
}

.table-row-head {
  font-weight: bold;
  border-bottom: 2px solid #324997;
}

.table-cell {
  min-width: 250px;
  text-align: center;
}
</style>
